"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableErrorOverlayAlert = exports.StyledTableErrorOverlayContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("../../components");
exports.StyledTableErrorOverlayContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: ${({ theme }) => theme.spacing(2)};
`;
exports.StyledTableErrorOverlayAlert = (0, styled_components_1.default)(components_1.Alert) `
  max-width: min(640px, 100%);
`;
